/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { useState } from 'react';
import {
	userService,
	AdminUserListResponse,
	AdminUserListFilters,
} from '../services/userService';

export function useAdminUserList() {
	const [usersData, setUsersData] = useState<AdminUserListResponse | null>(
		null
	);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchUsers = async (filters?: AdminUserListFilters) => {
		setLoading(true);
		setError(null);

		try {
			const data = await userService.getAdminUserList(filters);
			setUsersData(data);
		} catch (err: any) {
			console.error('Admin user list error:', err);
			setError(err.message || 'Failed to fetch users');
		} finally {
			setLoading(false);
		}
	};

	return {
		usersData,
		loading,
		error,
		fetchUsers,
	};
}
